
import {
  getCustomMeanRepo,
  getFlowTypeRepo,
  getCommonDropdownRepo,
  getExamSessionRepo,
  postExamSessionRepo,
  getRPMeritListRepo,
  postCustomMeanRepo,
  postFlowTypeRepo,
  getAppearedStudentsRepo,
  getCreateFormRepo,
  getFormListRepo,
  postCreateFormRepo,
  postRPMeritListRepo,
  postMeritListValidationCheckRepo,
  postUploadMeriListRepo,
  getDetailFlowTypeRepo,
  postAppearedStudentsRepo,
  getVariationFactorRepo,
  postVariationFactorRepo,
  getRPUsageListRepo,
  getRPUsageAnalyticsRepo,
  getCreateFormDetailRepo,
  postCreateFormDetailRepo,
} from '../../repositories/manageRP'
import {
  getCommonDropdownLoading,
  getCommonDropdownSuccess,
  getCommonDropdownFailure,
  getCommonDropdownClear,
  getCustomMeanLoading,
  getCustomMeanSuccess,
  getCustomMeanFailure,
  postCustomMeanLoading,
  postCustomMeanSuccess,
  postCustomMeanFailure,
  getInputFormListLoading,
  getInputFormListFailure,
  postInputFormListLoading,
  postInputFormListSuccess,
  postInputFormListFailure,
  getToolsDropdownLoading,
  getToolsDropdownSuccess,
  getToolsDropdownFailure,
  getYearLoading,
  getYearSuccess,
  getYearFailure,

  getEmailLoading,
  getEmailSuccess,
  getEmailFailure,

  getDeviceTypeLoading,
  getDeviceTypeSuccess,
  getDeviceTypeFailure,

  getInputFlowTypeLoading,
  getInputFlowTypeSuccess,
  getInputFlowTypeFailure,
  getExamSessionLoading,
  getExamSessionSuccess,
  getExamSessionFailure,
  postExamSessionLoading,
  postExamSessionSuccess,
  postExamSessionFailure,
  getShiftLoading,
  getShiftSuccess,
  getShiftFailure,
  getDifficultyLoading,
  getDifficultySuccess,
  getDifficultyFailure,
  getMeritListLoading,
  getMeritListSuccess,
  getMeritListFailure,
  getTypeLoading,
  getTypeSuccess,
  getTypeFailure,
  getProcessTypeLoading,
  getProcessTypeSuccess,
  getProcessTypeFailure,
  appearedStudentsLoading,
  appearedStudentsSuccess,
  appearedStudentsFailure,
  getCreateFormLoading,
  getCreateFormSucess,
  getCreateFormFailure,
  postCreateFormLoading,
  postCreateFormSucess,
  postCreateFormFailure,
  getInputFormListSuccess,
  postMeritListLoading,
  postMeritListSuccess,
  postMeritListFailure,
  postMeritListValidationCheckLoading,
  postMeritListValidationCheckSuccess,
  postMeritListValidationCheckFailure,
  postUploadMeriListLoading,
  postUploadMeritListSuccess,
  postUploadMeriListFailure,
  clearPostMeritListValidationCheckResponse,
  getDetailFlowTypeLoading,
  getDetailFlowTypeSuccess,
  getDetailFlowTypeFailure,
  postAppearedStudentsLoading,
  postAppearedStudentsSuccess,
  postAppearedStudentsFailure,
  postAppearedStudentClear,
  getCategoryLoading,
  getCategorySuccess,
  getCategoryFailure,
  getDisabilityLoading,
  getDisabilitySuccess,
  getDisabilityFailure,
  getStudentTypeLoading,
  getStudentTypeSuccess,
  getStudentTypeFailure,

  getVariationFactorLoading,
  getVariationFactorSuccess,
  getVariationFactorFailure,

  postVariationFactorLoading,
  postVariationFactorSuccess,
  postVariationFactorFailure,

  fetchToolsNameLoading,
  fetchToolsNameSuccess,
  fetchToolsNameFailure,
  fetchResultFlowTypeLoading,
  fetchResultFlowTypeSuccess,
  fetchResultFlowTypeFailure,
  fetchPresetTypeLoading,
  fetchPresetTypeSuccess,
  fetchPresetTypeFailure,
  getMappedProcessTypeLoading,
  getMappedProcessTypeSuccess,
  getMappedProcessTypeFailure,
  getInputProcessTypeLoading,
  getInputProcessTypeSuccess,
  getInputProcessTypeFailure,

  getUsageListLoading,
  getUsageListSuccess,
  getUsageListFailure,
  getUsageAnalyticsLoading,
  getUsageAnalyticsSuccess,
  getUsageAnalyticsFailure,

  getFieldTypeLoading,
  getFieldTypeSuccess,
  getFieldTypeFailure,

  getCreateFormDetailLoading,
  getCreateFormDetailSuccess,
  getCreateFormDetailFailure,

  postCreateFormDetailLoading,
  postCreateFormDetailSuccess,
  postCreateFormDetailFailure,
  postCreateFormDetailMessageFailure,

  getMappedCategoryDataLoading,
  getMappedCategoryDataSuccess,
  getMappedCategoryDataFailure,

} from '../../slices/manageRP'
import Cookies from 'universal-cookie'

// common dropdown
export const getCommonDropdown = (params) => {
  return async (dispatch) => {
    dispatch(getCommonDropdownLoading())
    await getCommonDropdownRepo(params)
      .then((response) => {
        if (response?.status >= 200 && response?.status <= 300) {
          dispatch(getCommonDropdownSuccess(response?.data?.data))
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch(getCommonDropdownFailure(error.message))
        }
      })
  }
}
// custom mean SD
export const getCustomMeanSD = (params) => {
  return async (dispatch) => {
    dispatch(getCustomMeanLoading())
    await getCustomMeanRepo(params)
      .then((response) => {
        if (response?.status >= 200 && response?.status <= 300) {
          dispatch(getCustomMeanSuccess(response?.data?.data))
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch(getCustomMeanFailure(error.message))
        }
      })
  }
}
export const postCustomMeanSD = (params) => {
  return async (dispatch) => {
    dispatch(postCustomMeanLoading())
    await postCustomMeanRepo(params)
      .then((response) => {
        if (response?.status >= 200 && response?.status <= 300) {
          dispatch(postCustomMeanSuccess(response?.data?.data))
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch(postCustomMeanFailure(error.message))
        }
      })
  }
}
// input flow/ result flow list
export const getInputFlowList = (params) => {
  return async (dispatch) => {
    dispatch(getInputFormListLoading())
    await getFlowTypeRepo(params)
      .then((response) => {
        if (response?.status >= 200 && response?.status <= 300) {
          dispatch(getInputFormListSuccess(response?.data?.data))
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch(getInputFormListFailure(error.message))
        }
      })
  }
}
//post input flow/ result flow list
export const postInputFlowList = (params) => {
  return async (dispatch) => {
    dispatch(postInputFormListLoading())
    await postFlowTypeRepo(params)
      .then((response) => {
        if (response?.status >= 200 && response?.status <= 300) {
          dispatch(postInputFormListSuccess(response?.data?.data))
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch(postInputFormListFailure(error?.response?.data))
        }
      })
  }
}
// tools dropdown
export const getToolsDropdown = (params) => {
  const cookies = new Cookies()
  let sessionKey = ''
  Object.keys(cookies.getAll())?.map((value, index) => {
    if (value?.includes('SESS') && !value?.includes('CSESS360'))
      sessionKey = value
  })
  const sessionValue = cookies.get(sessionKey)
  return async (dispatch) => {
    dispatch(getToolsDropdownLoading())
    await getCommonDropdownRepo(params, sessionValue)
      .then((response) => {
        if (response?.status >= 200 && response?.status <= 300) {
          dispatch(getToolsDropdownSuccess(response?.data?.data))
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch(getToolsDropdownFailure(error.message))
        }
      })
  }
}
//   year
export const getYearDropdown = (params) => {
  const cookies = new Cookies()
  let sessionKey = ''
  Object.keys(cookies.getAll())?.map((value, index) => {
    if (value?.includes('SESS') && !value?.includes('CSESS360'))
      sessionKey = value
  })
  const sessionValue = cookies.get(sessionKey)
  return async (dispatch) => {
    dispatch(getYearLoading())
    await getCommonDropdownRepo(params, sessionValue)
      .then((response) => {
        if (response?.status >= 200 && response?.status <= 300) {
          dispatch(getYearSuccess(response?.data?.data?.year))
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch(getYearFailure(error.message))
        }
      })
  }
}

// email dropdown
export const getEmailDropdown = (params) => {
  return async (dispatch) => {
    dispatch(getEmailLoading())
    await getCommonDropdownRepo(params)
      .then((response) => {
        if (response?.status >= 200 && response?.status <= 300) {
          dispatch(getEmailSuccess(response?.data?.data?.email))
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch(getEmailFailure(error.message))
        }
      })
  }
}
//device type dropdown
export const getDeviceTypeDropdown = (params) => {
  return async (dispatch) => {
    dispatch(getDeviceTypeLoading())
    await getCommonDropdownRepo(params)
      .then((response) => {
        if (response?.status >= 200 && response?.status <= 300) {
          dispatch(getDeviceTypeSuccess(response?.data?.data?.device_type))
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch(getDeviceTypeFailure(error.message))
        }
      })
  }
}

//  shift
export const getShiftDropdown = (params) => {
  const cookies = new Cookies()
  let sessionKey = ''
  Object.keys(cookies.getAll())?.map((value, index) => {
    if (value?.includes('SESS') && !value?.includes('CSESS360'))
      sessionKey = value
  })
  const sessionValue = cookies.get(sessionKey)
  return async (dispatch) => {
    dispatch(getShiftLoading())
    await getCommonDropdownRepo(params, sessionValue)
      .then((response) => {
        if (response?.status >= 200 && response?.status <= 300) {
          dispatch(getShiftSuccess(response?.data?.data))
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch(getShiftFailure(error.message))
        }
      })
  }
}
//  difficulty
export const getDifficultyDropdown = (params) => {
  const cookies = new Cookies()
  let sessionKey = ''
  Object.keys(cookies.getAll())?.map((value, index) => {
    if (value?.includes('SESS') && !value?.includes('CSESS360'))
      sessionKey = value
  })
  const sessionValue = cookies.get(sessionKey)
  return async (dispatch) => {
    dispatch(getDifficultyLoading())
    await getCommonDropdownRepo(params, sessionValue)
      .then((response) => {
        if (response?.status >= 200 && response?.status <= 300) {
          dispatch(getDifficultySuccess(response?.data?.data))
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch(getDifficultyFailure(error.message))
        }
      })
  }
}


//  disability dropdown
export const getDisabilityDropdown = (params) => {
  // const cookies = new Cookies()
  // let sessionKey = ''
  // Object.keys(cookies.getAll())?.map((value, index) => {
  //   if (value?.includes('SESS') && !value?.includes('CSESS360'))
  //     sessionKey = value
  // })
  // const sessionValue = cookies.get(sessionKey)
  return async (dispatch) => {
    dispatch(getDisabilityLoading())
    await getCommonDropdownRepo(params)
      .then((response) => {
        if (response?.status >= 200 && response?.status <= 300) {
          dispatch(getDisabilitySuccess(response?.data?.data))
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch(getDisabilityFailure(error.message))
        }
      })
  }
}

//  category dropdown
export const getCategoryDropdown = (params) => {
  // const cookies = new Cookies()
  // let sessionKey = ''
  // Object.keys(cookies.getAll())?.map((value, index) => {
  //   if (value?.includes('SESS') && !value?.includes('CSESS360'))
  //     sessionKey = value
  // })
  // const sessionValue = cookies.get(sessionKey)
  return async (dispatch) => {
    dispatch(getCategoryLoading())
    await getCommonDropdownRepo(params)
      .then((response) => {
        if (response?.status >= 200 && response?.status <= 300) {
          dispatch(getCategorySuccess(response?.data?.data))
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch(getCategoryFailure(error.message))
        }
      })
  }
}


//  exam_type dropdown
export const getStudentTypeDropdown = (params) => {
  // const cookies = new Cookies()
  // let sessionKey = ''
  // Object.keys(cookies.getAll())?.map((value, index) => {
  //   if (value?.includes('SESS') && !value?.includes('CSESS360'))
  //     sessionKey = value
  // })
  // const sessionValue = cookies.get(sessionKey)
  return async (dispatch) => {
    dispatch(getStudentTypeLoading())
    await getCommonDropdownRepo(params)
      .then((response) => {
        if (response?.status >= 200 && response?.status <= 300) {
          dispatch(getStudentTypeSuccess(response?.data?.data))
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch(getStudentTypeFailure(error.message))
        }
      })
  }
}




//   input flow type
export const getInputFlowTypeDropdown = (params) => {
  const cookies = new Cookies()
  let sessionKey = ''
  Object.keys(cookies.getAll())?.map((value, index) => {
    if (value?.includes('SESS') && !value?.includes('CSESS360'))
      sessionKey = value
  })
  const sessionValue = cookies.get(sessionKey)
  return async (dispatch) => {
    dispatch(getInputFlowTypeLoading())
    await getCommonDropdownRepo(params, sessionValue)
      .then((response) => {
        if (response?.status >= 200 && response?.status <= 300) {
          dispatch(
            getInputFlowTypeSuccess(response?.data?.data?.input_flow_type)
          )
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch(getInputFlowTypeFailure(error.message))
        }
      })
  }
}


export const getInputProcessTypeDropdown = (params) => {
  // const cookies = new Cookies()
  // let sessionKey = ''
  // Object.keys(cookies.getAll())?.map((value, index) => {
  //   if (value?.includes('SESS') && !value?.includes('CSESS360'))
  //     sessionKey = value
  // })
  // const sessionValue = cookies.get(sessionKey)
  return async (dispatch) => {
    dispatch(getInputProcessTypeLoading())
    await getCommonDropdownRepo(params)
      .then((response) => {
        if (response?.status >= 200 && response?.status <= 300) {
          dispatch(
            getInputProcessTypeSuccess(response?.data?.data?.input_process_type)
          )
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch(getInputProcessTypeFailure(error.message))
        }
      })
  }
}




// get mapped process type dropdown
export const getMappedProcessTypeDropdown = (params) => {
  // const cookies = new Cookies()
  // let sessionKey = ''
  // Object.keys(cookies.getAll())?.map((value, index) => {
  //   if (value?.includes('SESS') && !value?.includes('CSESS360'))
  //     sessionKey = value
  // })
  // const sessionValue = cookies.get(sessionKey)
  return async (dispatch) => {
    dispatch(getMappedProcessTypeLoading())
    await getCommonDropdownRepo(params)
      .then((response) => {
        if (response?.status >= 200 && response?.status <= 300) {
          dispatch(getMappedProcessTypeSuccess(response?.data?.data))
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch(getMappedProcessTypeFailure(error.message))
        }
      })
  }
}






// RP Session
export const getExamSession = (params) => {
  return async (dispatch) => {
    dispatch(getExamSessionLoading())
    await getExamSessionRepo(params)
      .then((response) => {
        if (response?.status >= 200 && response?.status <= 300) {
          dispatch(getExamSessionSuccess(response?.data?.data))
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch(getExamSessionFailure(error.message))
        }
      })
  }
}
export const postExamSession = (data) => {
  return async (dispatch) => {
    dispatch(postExamSessionLoading())
    await postExamSessionRepo(data)
      .then((response) => {
        if (response?.status >= 200 && response?.status <= 300) {
          dispatch(postExamSessionSuccess(response?.data?.data))
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch(postExamSessionFailure(error.message))
        }
      })
  }
}
// custom mean SD
export const getTypeDropdown = (params) => {
  return async (dispatch) => {
    dispatch(getTypeLoading())
    await getCommonDropdownRepo(params)
      .then((response) => {
        if (response?.status >= 200 && response?.status <= 300) {
          dispatch(getTypeSuccess(response?.data?.data))
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch(getTypeFailure(error.message))
        }
      })
  }
}
// custom mean SD
export const getProcessTypeDropdown = (params) => {
  return async (dispatch) => {
    dispatch(getProcessTypeLoading())
    await getCommonDropdownRepo(params)
      .then((response) => {
        if (response?.status >= 200 && response?.status <= 300) {
          dispatch(getProcessTypeSuccess(response?.data?.data))
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch(getProcessTypeFailure(error.message))
        }
      })
  }
}
export const getAppearedStudents = (params) => {
  return async (dispatch) => {
    dispatch(appearedStudentsLoading())
    await getAppearedStudentsRepo(params)
      .then((response) => {
        if (response?.status >= 200 && response?.status <= 300) {
          dispatch(appearedStudentsSuccess(response?.data?.data))
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch(appearedStudentsFailure(error.message))
        }
      })
  }
}
export const postAppearedStudents = (data) => {
  return async (dispatch) => {
    dispatch(postAppearedStudentsLoading())
    await postAppearedStudentsRepo(data)
      .then((response) => {
        if (response?.status >= 200 && response?.status <= 300) {
          dispatch(postAppearedStudentsSuccess(response?.data?.data))
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch(postAppearedStudentsFailure(error.message))
        }
      }).finally(()=>{
        setTimeout(()=>{
          dispatch(postAppearedStudentClear())
        },3000)
      })
  }
}
export const getCreateInputForm = (params) => {
  return async (dispatch) => {
    dispatch(getCreateFormLoading())
    await getCreateFormRepo(params)
      .then((response) => {
        if (response?.status >= 200 && response?.status <= 300) {
          dispatch(getCreateFormSucess(response?.data?.data))
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch(getCreateFormFailure(error.message))
        }
      })
  }
}
export const postCreateInputForm = ({ product_id, data }) => {
  return async (dispatch) => {
    dispatch(postCreateFormLoading())
    try {
      const response = await postCreateFormRepo(data, { product_id })
      if (response?.status >= 200 && response?.status <= 300) {
        dispatch(postCreateFormSucess(response?.data?.data))
      }
    } catch (error) {
      if (error && error.response) {
        dispatch(postCreateFormFailure(error.message))
      }
    }
  }
}
export const getInputFormListTableData = (params) => {
  return async (dispatch) => {
    dispatch(getInputFormListLoading())
    await getFormListRepo(params)
      .then((response) => {
        if (response?.status >= 200 && response?.status <= 300) {
          dispatch(getInputFormListSuccess(response?.data?.data))
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch(getInputFormListFailure(error.message))
        }
      })
  }
}

// RP Merit List
export const getRPMeritList = (params) => {
  return async (dispatch) => {
    dispatch(getMeritListLoading())
    await getRPMeritListRepo(params)
      .then((response) => {
        if (response?.status >= 200 && response?.status <= 300) {
          dispatch(getMeritListSuccess(response?.data?.data))
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch(getMeritListFailure(error.message))
        }
      })
  }
}

export const postRPMeritList = (data) => {
  return async (dispatch) => {
    dispatch(postMeritListLoading())
    await postRPMeritListRepo(data)
      .then((response) => {
        if (response?.status >= 200 && response?.status <= 300) {
          dispatch(postMeritListSuccess(response?.data?.data))
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch(postMeritListFailure(error.message))
        }
      })
  }
}

export const postMeritListValidationCheck = (data) => {
  return async (dispatch) => {
    dispatch(postMeritListValidationCheckLoading())
    await postMeritListValidationCheckRepo(data)
      .then((response) => {
        if (response?.status >= 200 && response?.status <= 300) {
          dispatch(postMeritListValidationCheckSuccess(response?.data?.data))
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch(
            postMeritListValidationCheckFailure(
              error?.response?.data?.data?.error
            )
          )
        }
      })
  }
}

export const postUploadMeritList = (data) => {
  return async (dispatch) => {
    dispatch(postUploadMeriListLoading())
    await postUploadMeriListRepo(data)
      .then((response) => {
        if (response?.status >= 200 && response?.status <= 300) {
          dispatch(postUploadMeritListSuccess(response?.data?.data))
          dispatch(clearPostMeritListValidationCheckResponse())
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch(postUploadMeriListFailure(error.message))
        }
      })
  }
}

// detail input/result flow action
export const getDetailFlowType = (params) => {
  return async (dispatch) => {
    dispatch(getDetailFlowTypeLoading())
    await getDetailFlowTypeRepo(params)
      .then((response) => {
        if (response?.status >= 200 && response?.status <= 300) {
          dispatch(getDetailFlowTypeSuccess(response?.data?.data))
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch(getDetailFlowTypeFailure(error.message))
        }
      })
  }
}

export const getVariationFactor = (params) => {
  return async (dispatch) => {
    dispatch(getVariationFactorLoading());
    await getVariationFactorRepo(params)
      .then((response) => {
        if (response?.status >= 200 && response?.status <= 300) {
          dispatch(getVariationFactorSuccess(response?.data?.data));
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch(getVariationFactorFailure(error.message));
        }
      });
  };
};

export const postVariationFactor = (params) => {
  return async (dispatch) => {
    dispatch(postVariationFactorLoading());
    await postVariationFactorRepo(params)
      .then((response) => {
        if (response?.status >= 200 && response?.status <= 300) {
          dispatch(postVariationFactorSuccess(response?.data?.data));
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch(postVariationFactorFailure(error.message));
        }
      });
  };
};

// common params

export const fetchToolsName = (params) => async (dispatch) => {
  dispatch(fetchToolsNameLoading());
  try {

    const response = await getCommonDropdownRepo(params);

    if (response?.status >= 200 && response?.status <= 300) {
      dispatch(fetchToolsNameSuccess(response?.data?.data));
    }
  } catch (error) {
    dispatch(fetchToolsNameFailure(error.message));
  }
};

// Result Flow Type
export const fetchResultFlowType = (params) => async (dispatch) => {
  dispatch(fetchResultFlowTypeLoading());
  try {

    const response = await getCommonDropdownRepo(params);
    if (response?.status >= 200 && response?.status <= 300) {
      dispatch(fetchResultFlowTypeSuccess(response?.data?.data));
    }
  } catch (error) {
    dispatch(fetchResultFlowTypeFailure(error.message));
  }
};

// Preset Type
export const fetchPresetType = (params) => async (dispatch) => {
  dispatch(fetchPresetTypeLoading());
  try {
    const response = await getCommonDropdownRepo(params);
    if (response?.status >= 200 && response?.status <= 300) {
      dispatch(fetchPresetTypeSuccess(response?.data?.data));
    }
  } catch (error) {
    dispatch(fetchPresetTypeFailure(error.message));
  }
};

// RP usage Report
export const getUsageList = (params) => {
  return async (dispatch) => {
    dispatch(getUsageListLoading())
    await getRPUsageListRepo(params)
      .then((response) => {
        if (response?.status >= 200 && response?.status <= 300) {
          dispatch(getUsageListSuccess(response?.data?.data))
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch(getUsageListFailure(error.message))
        }
      })
  }
}

export const getUsageAnalytics = (params) => {
  return async (dispatch) => {
    dispatch(getUsageAnalyticsLoading())
    await getRPUsageAnalyticsRepo(params)
      .then((response) => {
        if (response?.status >= 200 && response?.status <= 300) {
          dispatch(getUsageAnalyticsSuccess(response?.data?.data))
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch(getUsageAnalyticsFailure(error.message))
        }
      })
  }
}

// field Type
export const getFieldTypeDropdown = (params) => {
  return async (dispatch) => {
    dispatch(getFieldTypeLoading())
    await getCommonDropdownRepo(params)
      .then((response) => {
        if (response?.status >= 200 && response?.status <= 300) {
          dispatch(getFieldTypeSuccess(response?.data?.data?.rp_field_type
          ))
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch(getFieldTypeFailure(error.message))
        }
      })
  }
}

// create form add/edit
export const getCreateFormDetail = (params) => {
  return async (dispatch) => {
    dispatch(getCreateFormDetailLoading())
    await getCreateFormDetailRepo(params)
      .then((response) => {
        if (response?.status >= 200 && response?.status <= 300) {
          dispatch(getCreateFormDetailSuccess(response?.data?.data))
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch(getCreateFormDetailFailure(error.message))
        }
      })
  }
}

export const postCreateFormDetail = (params) => {
  return async (dispatch) => {
    dispatch(postCreateFormDetailLoading());
    await postCreateFormDetailRepo(params)
      .then((response) => {
        if (response?.status >= 200 && response?.status <= 300) {
          dispatch(postCreateFormDetailSuccess(response?.data?.data));
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch(postCreateFormDetailMessageFailure(error.message));
          dispatch(postCreateFormDetailFailure(error.response?.data?.data));
        }
      });
  };
};

export const getMappedCategory = (params) => {
  return async (dispatch) => {
    dispatch(getMappedCategoryDataLoading());
    await getCommonDropdownRepo(params)
      .then((response) => {
        if (response?.status >= 200 && response?.status <= 300) {
          dispatch(getMappedCategoryDataSuccess(response?.data?.data?.mapped_category));
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch(getMappedCategoryDataFailure(error.message));
        }
      });
  };
};
